<div class="header-bar" [ngClass]="{ 'header-bar--logged': isUserLogged, 'is-hidden-touch': isUserLogged }">
  <div class="level">
    <div
      class="level-left level-bar is-hidden-touch"
      [class.nb]="!isBusiness && !isTaxAdvisor"
      [ngClass]="{ 'level-bar--logout': !isUserLogged }"
    >
      <div class="logo-wrapper level-item">
        <a routerLink="/dashboard">
          @if (isUserLogged) {
            <img src="assets/svg/logo_sm.svg" />
          } @else {
            <img src="assets/svg/logo_sm.svg" />
          }
        </a>
      </div>
      @if (isUserLogged) {
        <div class="header-bar__search-engine">
          @if (isBusiness || isTaxAdvisor) {
            <app-search-engine></app-search-engine>
          }
        </div>
      }
    </div>
    @if (isUserLogged) {
      <div class="level-right logout-wrapper is-hidden-touch" [class.nb]="!isBusiness && !isTaxAdvisor">
        @if (!isBusiness) {
          <button class="coupons-btn" (click)="openCoupons()">{{ "COUPONS_HEADER" | translate }}</button>
        }
        @if (isBusiness) {
          <span class="username level-item">{{
            userLogin?.length > 20 ? (userLogin | slice: 0 : 20) + "..." : userLogin || ""
          }}</span>
        }
        <app-choose-language></app-choose-language>
        <div class="header-bar__hamburger" (click)="toggleSideNav()">
          <div class="header-bar__hamburger-stage"></div>
          <div class="header-bar__hamburger-stage"></div>
          <div class="header-bar__hamburger-stage"></div>
        </div>
      </div>
    }
    @if (!isUserLogged) {
      <div class="level-right is-hidden-touch">
        <div class="level-item header-bar__lang">
          <app-choose-language class="header-bar__lang-wr" [mode]="'header'"></app-choose-language>
        </div>
        <div class="level-item header-bar__lang">
          <app-my-account [mobile]="false"></app-my-account>
        </div>
      </div>
    }
    <!-- @if (!isUserLogged) {
      <div class="level-right is-hidden-desktop">
        <div class="logo-wrapper level-item">
          <a routerLink="/">
            <img src="assets/svg/logo_sm.svg">
          </a>
        </div>
        <div class="level-item header-bar__lang">
          <app-choose-language class="header-bar__lang-wr" [mode]="'header'"></app-choose-language>
          <app-my-account [mobile]="true"></app-my-account>
        </div>
      </div>
    } -->
  </div>
  @if (workflowControllerService.isWorkflowHeaderProgressShown) {
    <div id="headerProgress" [style.width]="(workflowControllerService.statement | statementProgressPipe) + '%'"></div>
  }
</div>
